import React from 'react'
import PropTypes from 'prop-types'
import AmenityIcon from '../Amenities/AmenityIcon/AmenityIcon'

const SizableIcon = ({ ancillary, size, disableTooltip, strikeThroughColor }) => (
  <AmenityIcon
    name={ancillary.name}
    inclusion={ancillary.inclusion}
    description={ancillary.description}
    size={size}
    strikeThroughColor={strikeThroughColor}
    useSentenceText
    allowHorizontalAlignment
    isBrandedFaresVariant
    disableTooltip={disableTooltip}
  />
)

SizableIcon.propTypes = {
  size: PropTypes.number,
  ancillary: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    inclusion: PropTypes.string,
    size: PropTypes.number,
    desktopSize: PropTypes.number,
  }),
  disableTooltip: PropTypes.bool,
  strikeThroughColor: PropTypes.string,
}

SizableIcon.defaultProps = {
  strikeThroughColor: 'text.dark',
}

export default SizableIcon
